export default {
    name: 'marking--batchInfo',
    apiService: 'shoes',
    apiPath: '/admin/batch_info',

    enums: {
        status: ['NEW', 'SENDING', 'SENT', 'ERROR']
    }
};